import React from "react";
import { X } from "lucide-react";
import { useAskTessa } from "@cmp-src/tessa/AskTessaProvider";
import { Button } from "@cmp-src/primitives/button";
import { cn } from "@gettactic/helpers";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider
} from "@cmp-src/primitives/tooltip";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";
import { AiIcon } from "@cmp-src/icons/icons";

export interface ChatBotBubbleProps {
  className?: string;
}

export const ChatBotBubble: React.FC<ChatBotBubbleProps> = ({ className }) => {
  const askTessa = useAskTessa();
  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");
  if (!askTessa) return null;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <Button
            variant="default"
            onClick={() => askTessa.tessaDisclosure.toggle()}
            className={cn(
              "flex h-14 w-14 items-center justify-center rounded-full shadow-md transition-all duration-300 hover:shadow-black/30 hover:shadow-lg",
              className
            )}
          >
            {askTessa.tessaDisclosure.isOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <AiIcon className="h-6 w-6" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side={isMd ? "right" : "top"} align="center">
          <span className={"flex items-center gap-1"}>
            <AiIcon className={"size-4"} /> Ask tessa -{" "}
            <span className={"text-neutral-600 text-sm"}>⌘⇧A</span>
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
